import { render, staticRenderFns } from "./LifestyleFeed.vue?vue&type=template&id=4b46ec71&"
import script from "./LifestyleFeed.vue?vue&type=script&lang=js&"
export * from "./LifestyleFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports